/**
 * Executa `fn` com retry e backoff linear.
 * Usado para fetches de tema/tradução do tenant que podem falhar de forma
 * transitória (rede instável) e hoje não tinham nenhuma nova tentativa.
 */
export const withRetry = async (fn, { attempts = 3, delayMs = 500 } = {}) => {
  let lastError;
  for (let i = 0; i < attempts; i++) {
    try {
      return await fn();
    } catch (error) {
      lastError = error;
      if (i < attempts - 1) {
        await new Promise(resolve => setTimeout(resolve, delayMs * (i + 1)));
      }
    }
  }
  throw lastError;
};
